import { render } from "./SvgGear.vue?vue&type=template&id=e36ccd9e"
import script from "./SvgGear.vue?vue&type=script&lang=js"
export * from "./SvgGear.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__